import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { string, bool } from 'prop-types';
import { ExternalLink } from '../../components';

import css from './ListingPage.module.css';

const SectionHelpfulResources = props => {
  const { licenseLink, regulationsLink, showRegulationsLink } = props;

  // Render the container only if we at least have a license link
  // or a regulations link (and we’re allowed to show it)
  const shouldRenderContainer = licenseLink || (regulationsLink && showRegulationsLink);

  return shouldRenderContainer ? (
    <div className={css.helpfulResources}>
      <strong>
        <FormattedHTMLMessage id="ListingPage.helpfulResources" />
      </strong>
      <div className={css.linkContainer}>
        {licenseLink ? (
          <div className={css.links}>
            <ExternalLink
              className={css.linkDecor}
              key="linkToLicense"
              href={licenseLink}
              title={SectionHelpfulResources.goToLicense}
            >
              <FormattedHTMLMessage id="ListingPage.licenseLink" />
            </ExternalLink>
          </div>
        ) : null}

        {regulationsLink && showRegulationsLink ? (
          <div className={css.links}>
            <ExternalLink
              className={css.linkDecor}
              key="linkToRegulations"
              href={regulationsLink}
              title={SectionHelpfulResources.goToRegulations}
            >
              <FormattedHTMLMessage id="ListingPage.regulationsLink" />
            </ExternalLink>
          </div>
        ) : null}
      </div>
    </div>
  ) : null;
};

SectionHelpfulResources.defaultProps = {
  licenseLink: null,
  regulationsLink: null,
  showRegulationsLink: false,
};

SectionHelpfulResources.propTypes = {
  licenseLink: string,
  regulationsLink: string,
  showRegulationsLink: bool,
};

export default SectionHelpfulResources;
